import { useContext } from "react";
import { StepperControlContext, } from "../contexts/StepperControlContext";
export function useStepperControl() {
    var context = useContext(StepperControlContext);
    if (!context) {
        throw new Error("useStepperControl must be used within a StepperControlProvider");
    }
    return context;
}
